import { createGlobalStyle } from 'styled-components';

import Gothic from '@/assets/fonts/gothic.ttf';

const VariationsStyles = createGlobalStyle`
  @font-face {
    font-family: 'Gothic';
    src: url(${Gothic});
  }   

  .generated-images-holder-var32 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var32 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
  }

  .author-row-var32 {
    display: flex;
    align-items: center;
    margin-bottom: 32px;
  }

  .author-name-var32 {
    font-weight: 700;
    font-size: 34px;
    color: #000;
    font-family: Arial, Helvetica, sans-serif;
  }

  .author-name-var32__blue {
    color: #3D5798;
  }

  .author-image-var32 {
    width: 93px;
    height: 93px;
    object-fit: cover;
    margin-right: 22px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .right-text-holder-var32, .left-text-holder-var32 {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    background-color: white;
    padding: 33px;
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .left-text-holder-var32 {
    left: 0;
    right: auto;
  }

  .right-text-var32 {
    text-align: center;
    color: #1C2327;
    font-family: Gothic;
    letter-spacing: -0.05em;
    line-height: 1.2;
    p {
      display: inline;
    }
  }
  .break-var32 {
    position: absolute;
    width: 12px;
    height: 100%;
    background-color: black;
    left: 0;
    top: 0;
    right: 0;
    margin-left: calc(50% - 6px);
    z-index: 1;
  }
`;

export default VariationsStyles;
